const vars = {
	breakpoint: {
		mobile: 450,
		tablet: 700,
		laptop: 1000,
		desktop: 1200,
		largest: 1600,
		wide: 1920,
	},
};

export { vars };
